<!-- Translated: no -->
<template>
  <div v-if="hasChanges">
    <h1>Uppdatera uppgifter</h1>

    <p>Vill du uppdatera ditt konto med följande uppgifter?</p>

    <table>
      <tr v-for="change in config.changes">
        <th>{{ change.title }}</th>
        <td>{{ change.to }}</td>
      </tr>
    </table>

    <p>&nbsp;</p>

    <div :class="{disabled: loading}">
      <button @click="update" class="small">Ja, uppdatera</button>
      <button @click="close" class="small white border">Nej</button>
      <p>&nbsp;</p>
      <button @click="goToMyPages" class="small white border">Gå till mina sidor</button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import API from '@/classes/API';

export default {
  props: {
    config: {},
  },
  methods: {
    ...mapMutations([
      'closeAllModals',
    ]),
    async update() {
      const details = {};
      this.loading = true;

      /* eslint-disable */
      console.log(this.config.changes);
      for (let i in this.config.changes) {
        details[i] = this.config.changes[i].to;
      }
      console.log(details);
      /* eslint-enable */

      await API.post('/account/update', details);

      this.loading = false;

      this.close();
    },
    close() {
      this.closeAllModals();
    },
    goToMyPages() {
      this.$router.push({
        name: 'my pages details',
      });
      this.closeAllModals();
    },
  },
  data() {
    return {
      changes: [],
      loading: false,
    };
  },
  computed: {
    hasChanges() {
      return Object.keys(this.config.changes).length;
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.disabled
  disabled()

table
  width 100%
  th
    text-align left
</style>



// WEBPACK FOOTER //
// UpdateAddress.vue?58b19638